export const CopyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M11.3333 11.3333H14V2H4.66667V4.66667"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="2"
      y="4.66667"
      width="9.33333"
      height="9.33333"
      rx="1"
      stroke="#333333"
      strokeWidth="1.5"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <g clipPath="url(#clip0_1780_1712)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 3.8335C2 3.28121 2.44772 2.8335 3 2.8335H13C13.5523 2.8335 14 3.28121 14 3.8335V15.1668C14 15.7191 13.5523 16.1668 13 16.1668H3C2.44772 16.1668 2 15.7191 2 15.1668V3.8335ZM4 4.8335V14.1668H12V4.8335H4Z"
        fill="#333333"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 12.1665H5V10.1665H11V12.1665Z"
        fill="#333333"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.333336 2.8335H15.6667V4.8335H0.333336V2.8335Z"
        fill="#333333"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.55278 1.35281C5.72832 1.03257 6.06447 0.833496 6.42967 0.833496H9.59237C9.96062 0.833496 10.2991 1.03588 10.4733 1.36029L11.5476 3.36029C11.7141 3.6702 11.7055 4.04479 11.5249 4.34672C11.3444 4.64865 11.0185 4.8335 10.6667 4.8335H5.33334C4.98003 4.8335 4.65294 4.64706 4.4729 4.34306C4.29287 4.03906 4.28661 3.66263 4.45644 3.35281L5.55278 1.35281Z"
        fill="#333333"
      />
    </g>
    <defs>
      <clipPath id="clip0_1780_1712">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ReportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <mask id="path-1-inside-1_1780_1619" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.55744 3.01076C6.65278 1.14745 9.34723 1.14746 10.4426 3.01076L15.0298 10.8142C16.1401 12.703 14.7782 15.0834 12.5872 15.0834H3.41277C1.22179 15.0834 -0.140124 12.703 0.970204 10.8142L5.55744 3.01076Z"
      />
    </mask>
    <path
      d="M10.4426 3.01076L8.7184 4.02431L10.4426 3.01076ZM5.55744 3.01076L3.83328 1.99722V1.99722L5.55744 3.01076ZM15.0298 10.8142L13.3056 11.8278V11.8278L15.0298 10.8142ZM0.970204 10.8142L2.69436 11.8278H2.69436L0.970204 10.8142ZM12.1667 1.99722C10.2982 -1.18136 5.70181 -1.18137 3.83328 1.99722L7.2816 4.0243C7.60376 3.47627 8.39624 3.47627 8.7184 4.02431L12.1667 1.99722ZM16.754 9.80067L12.1667 1.99722L8.7184 4.02431L13.3056 11.8278L16.754 9.80067ZM12.5872 17.0834C16.3248 17.0834 18.6481 13.0227 16.754 9.80067L13.3056 11.8278C13.6322 12.3833 13.2317 13.0834 12.5872 13.0834V17.0834ZM3.41277 17.0834H12.5872V13.0834H3.41277V17.0834ZM-0.753957 9.80067C-2.64805 13.0227 -0.324786 17.0834 3.41277 17.0834V13.0834C2.76836 13.0834 2.3678 12.3833 2.69436 11.8278L-0.753957 9.80067ZM3.83328 1.99722L-0.753957 9.80067L2.69436 11.8278L7.2816 4.0243L3.83328 1.99722Z"
      fill="#333333"
      mask="url(#path-1-inside-1_1780_1619)"
    />
    <path d="M8 5.83301L8 9.83301" stroke="#333333" strokeWidth="1.66667" />
    <path d="M8 10.5V12.1667" stroke="#333333" strokeWidth="1.66667" />
  </svg>
);

export const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M2 10V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V10"
      stroke="#333333"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M8 3V11M8 11L4.5 7.63158M8 11L11.5 7.63158"
      stroke="#333333"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const BackIcon = () => (
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 19l-7-7 7-7"
    />
  </svg>
);

export const RefreshIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className="cursor-pointer hover:opacity-80"
  >
    <path d="M14 2.66675V8.00008" stroke="#999999" strokeWidth="2" />
    <path d="M2 8V13.3333" stroke="#999999" strokeWidth="2" />
    <path
      d="M14 8C14 4.6863 11.3137 2 8 2C6.30483 2 4.77387 2.70299 3.6827 3.83333M2 8C2 11.3137 4.6863 14 8 14C9.61853 14 11.0874 13.3591 12.1667 12.3173"
      stroke="#999999"
      strokeWidth="2"
    />
  </svg>
);

export const StarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className="w-[16px] h-[16px] aspect-square flex-shrink-0"
  >
    <path
      d="M6.63439 3.02136C7.01168 2.00712 7.20033 1.5 7.53439 1.5C7.86846 1.5 8.0571 2.00712 8.43439 3.02136L9.38997 5.5902C9.46532 5.79274 9.50299 5.89401 9.57726 5.96789C9.65152 6.04176 9.75333 6.07924 9.95694 6.15418L12.5394 7.10474C13.559 7.48004 14.0688 7.66769 14.0688 8C14.0688 8.33231 13.559 8.51996 12.5394 8.89526L9.95694 9.84582C9.75333 9.92076 9.65152 9.95824 9.57726 10.0321C9.50299 10.106 9.46532 10.2073 9.38997 10.4098L8.43439 12.9786C8.0571 13.9929 7.86846 14.5 7.53439 14.5C7.20033 14.5 7.01168 13.9929 6.63439 12.9786L5.67881 10.4098C5.60346 10.2073 5.56579 10.106 5.49153 10.0321C5.41726 9.95824 5.31545 9.92076 5.11184 9.84582L2.52941 8.89526C1.5098 8.51996 1 8.33231 1 8C1 7.66769 1.5098 7.48004 2.52941 7.10474L5.11184 6.15418C5.31545 6.07924 5.41726 6.04176 5.49153 5.96789C5.56579 5.89401 5.60346 5.79274 5.67881 5.5902L6.63439 3.02136Z"
      fill="#1673FF"
    />
    <path
      d="M12.3624 10.8802C12.551 10.3731 12.6454 10.1196 12.8124 10.1196C12.9794 10.1196 13.0738 10.3731 13.2624 10.8802L13.4486 11.3808C13.4863 11.4821 13.5051 11.5327 13.5422 11.5696C13.5794 11.6066 13.6303 11.6253 13.7321 11.6628L14.2353 11.848C14.7451 12.0357 15 12.1295 15 12.2956C15 12.4618 14.7451 12.5556 14.2353 12.7433L13.7321 12.9285C13.6303 12.966 13.5794 12.9847 13.5422 13.0216C13.5051 13.0586 13.4863 13.1092 13.4486 13.2105L13.2624 13.7111C13.0738 14.2182 12.9794 14.4717 12.8124 14.4717C12.6454 14.4717 12.551 14.2182 12.3624 13.7111L12.1762 13.2105C12.1385 13.1092 12.1197 13.0586 12.0826 13.0216C12.0454 12.9847 11.9945 12.966 11.8927 12.9285L11.3895 12.7433C10.8797 12.5556 10.6248 12.4618 10.6248 12.2956C10.6248 12.1295 10.8797 12.0357 11.3895 11.848L11.8927 11.6628C11.9945 11.6253 12.0454 11.6066 12.0826 11.5696C12.1197 11.5327 12.1385 11.4821 12.1762 11.3808L12.3624 10.8802Z"
      fill="#1673FF"
    />
    <path
      d="M10.9229 2.76624C11.1116 2.25912 11.2059 2.00556 11.3729 2.00556C11.54 2.00556 11.6343 2.25912 11.8229 2.76624L11.8795 2.91842C11.9172 3.0197 11.9361 3.07033 11.9732 3.10727C12.0103 3.14421 12.0612 3.16294 12.163 3.20042L12.316 3.25673C12.8258 3.44438 13.0807 3.53821 13.0807 3.70436C13.0807 3.87051 12.8258 3.96438 12.316 4.15199L12.163 4.2083C12.0612 4.24578 12.0103 4.26451 11.9732 4.30145C11.9361 4.33839 11.9172 4.38902 11.8795 4.49029L11.8229 4.64248C11.6343 5.1496 11.54 5.40316 11.3729 5.40316C11.2059 5.40316 11.1116 5.1496 10.9229 4.64248L10.8663 4.49029C10.8287 4.38902 10.8098 4.33839 10.7727 4.30145C10.7356 4.26451 10.6847 4.24578 10.5828 4.2083L10.4299 4.15199C9.92006 3.96434 9.66516 3.87051 9.66516 3.70436C9.66516 3.53821 9.92006 3.44438 10.4299 3.25673L10.5828 3.20042C10.6847 3.16294 10.7356 3.14421 10.7727 3.10727C10.8098 3.07033 10.8287 3.0197 10.8663 2.91842L10.9229 2.76624Z"
      fill="#1673FF"
    />
  </svg>
);

export const MailIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.5"
        y="4.27441"
        width="17"
        height="13.8684"
        stroke="#333333"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M11 12.3517L2.5 6.53589V4.5H19.0526V6.53589L11 12.3517Z"
        stroke="#333333"
        stroke-width="2"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const LoginBackIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33301 7.66634L9.99967 14.333L16.6663 7.66634"
        stroke="#999999"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.6666 1.66642L9.99993 6.99976L15.3333 1.66642"
        stroke="#999999"
        stroke-opacity="0.25"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const EyeCloseIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00004 12.5C4.31814 12.5 1.33337 8.5 1.33337 8.5C1.33337 8.5 1.83973 7.82142 2.69258 7.02325M8.00004 4.5C11.6819 4.5 14.6667 8.5 14.6667 8.5C14.6667 8.5 14.105 9.25273 13.1684 10.1051"
      stroke="#999999"
      stroke-width="2"
      stroke-linecap="square"
    />
    <path
      d="M6.77144 7.37378C6.49941 7.67038 6.33337 8.06581 6.33337 8.50001C6.33337 9.42048 7.07957 10.1667 8.00004 10.1667C8.45427 10.1667 8.86607 9.98495 9.16671 9.69025"
      stroke="#999999"
      stroke-width="1.33333"
      stroke-linecap="square"
    />
    <path
      d="M14 14.5L2 2.5"
      stroke="#999999"
      stroke-width="2"
      stroke-linecap="square"
    />
  </svg>
);
export const EyeOpenIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_356_8553)">
      <path
        d="M15 8.66719C15 8.66719 12.9 13.2172 8 13.2172C3.1 13.2172 1 8.66719 1 8.66719C1 8.66719 3.1 4.11719 8 4.11719C12.9 4.11719 15 8.66719 15 8.66719Z"
        stroke="#999999"
        stroke-width="2"
      />
      <circle cx="8.00065" cy="8.66667" r="1.66667" fill="#999999" />
    </g>
    <defs>
      <clipPath id="clip0_356_8553">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 5.5L19 19.5"
      stroke="#999999"
      stroke-width="2.5"
      stroke-linejoin="round"
    />
    <path
      d="M19 5.5L5 19.5"
      stroke="#999999"
      stroke-width="2.5"
      stroke-linejoin="round"
    />
  </svg>
);

export const NewBackIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_356_8294)">
      <path
        d="M10 4.5L3.41421 11.0858C2.63316 11.8668 2.63317 13.1332 3.41421 13.9142L10 20.5"
        stroke="#999999"
        stroke-width="2.5"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_356_8294">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ClearIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="9" cy="9" r="9" fill="black" fill-opacity="0.06" />
    <g opacity="0.65">
      <path
        d="M5.5 5.5L12.5 12.5"
        stroke="#999999"
        stroke-width="1.6"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 5.5L5.5 12.5"
        stroke="#999999"
        stroke-width="1.6"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export const TopCloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.6" clip-path="url(#clip0_356_7636)">
      <circle cx="12" cy="12" r="9.5" stroke="white" stroke-width="2.5" />
      <path d="M15.5 8.5L8.5 15.5" stroke="white" stroke-width="2.5" />
      <path d="M15.5 15.5L8.5 8.5" stroke="white" stroke-width="2.5" />
    </g>
    <defs>
      <clipPath id="clip0_356_7636">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const GoogleIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="11" cy="11" r="11" fill="white" />
    <path
      d="M6.92716 10.9999C6.92716 10.5554 7.00299 10.129 7.13716 9.72944L4.78166 7.96777C4.3084 8.90838 4.06263 9.94698 4.06415 10.9999C4.06415 12.0896 4.32199 13.1174 4.78049 14.0298L7.13482 12.2652C6.99754 11.8575 6.92741 11.4302 6.92716 10.9999Z"
      fill="#FBBC05"
    />
    <path
      d="M11.0642 6.95576C12.05 6.95576 12.9408 7.2976 13.6408 7.8576L15.6772 5.86668C14.4364 4.8091 12.8457 4.15576 11.0642 4.15576C8.29801 4.15576 5.92034 5.70451 4.78168 7.96785L7.13834 9.72951C7.68084 8.11601 9.22784 6.95576 11.0642 6.95576Z"
      fill="#EA4335"
    />
    <path
      d="M11.0642 15.0443C9.22726 15.0443 7.68026 13.884 7.13718 12.2705L4.78168 14.0322C5.91976 16.2955 8.29743 17.8443 11.0642 17.8443C12.771 17.8443 14.4008 17.251 15.6247 16.1386L13.3882 14.4458C12.7576 14.8348 11.9631 15.0443 11.0636 15.0443"
      fill="#34A853"
    />
    <path
      d="M17.7457 10.9999C17.7457 10.5956 17.6815 10.1599 17.5864 9.75562H11.0636V12.3999H14.8179C14.6307 13.3017 14.1197 13.9947 13.3888 14.4456L15.6247 16.1384C16.9098 14.9706 17.7457 13.2311 17.7457 10.9999Z"
      fill="#4285F4"
    />
  </svg>
);
